import { Banner, Button } from '@nexus/ui';
import { useState, useSyncExternalStore } from 'react';
import { useTranslation } from 'react-i18next';
import { isAppUpdated, onAppUpdate } from '../offline/app-update';

/**
 * Says below the top bar that a new version of the app is there, so nobody keeps working with an
 * old build without knowing. "Neu laden" loads it now; "Später" hides the notice, and the next page
 * change loads the new version (docs/ui/design-system.md, Caching).
 */
export function AppUpdateNotice() {
  const { t } = useTranslation();
  const updated = useSyncExternalStore(onAppUpdate, isAppUpdated);
  const [dismissed, setDismissed] = useState(false);
  if (!updated || dismissed) return null;
  return (
    <Banner
      tone="info"
      layout="bar"
      icon="refresh-cw"
      role="status"
      action={
        <div className="flex items-center gap-1">
          <Button variant="ghost" size="sm" onClick={() => setDismissed(true)}>
            {t('shell.update.later')}
          </Button>
          <Button variant="primary" size="sm" onClick={() => window.location.reload()}>
            {t('shell.update.reload')}
          </Button>
        </div>
      }
    >
      {t('shell.update.available')}
    </Banner>
  );
}
